import { render, staticRenderFns } from "./AccountBanksTable.vue?vue&type=template&id=0160381c&scoped=true"
import script from "./AccountBanksTable.vue?vue&type=script&lang=js"
export * from "./AccountBanksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160381c",
  null
  
)

export default component.exports